var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moment from "moment";
export var advDeclineStreamingUpdated = function (data, stream) {
    return data.map(function (z) {
        if (z.symbol === stream.symbol) {
            return __assign(__assign({}, z), { low: stream.low, high: stream.high, target: stream.target });
        }
        return z;
    });
};
export var advDeclineQuoteStreamingUpdated = function (data, stream) {
    return data.map(function (z) {
        return __assign(__assign({}, z), { stockAdvanceList: z.stockAdvanceList.map(function (x) {
                if (x.symbol === stream.symbol) {
                    return __assign(__assign({}, x), { change: stream.changePrice, changePercentage: stream.changePercentage, StocklatestTradingPrice: stream.curPrice });
                }
                return x;
            }), stockkDeclineList: z.stockkDeclineList.map(function (n) {
                if (n.symbol === stream.symbol) {
                    return __assign(__assign({}, n), { change: stream.changePrice, changePercentage: stream.changePercentage, StocklatestTradingPrice: stream.curPrice });
                }
                return n;
            }) });
    });
};
export var indicesStreamingUpdated = function (data, streaming) {
    return data.map(function (x) {
        if (x.symbol) {
            if ((x === null || x === void 0 ? void 0 : x.symbol) === streaming.symbol) {
                return __assign(__assign({}, x), { latestTradePrice: streaming.curPrice, high: x.high < streaming.high ? streaming.high : x.high, low: x.low > streaming.low ? streaming.low : x.low });
            }
        }
        return x;
    });
};
export var indicesViewAllStreamingUpdated = function (data, streaming, period) {
    return data.map(function (x) {
        if (x.symbol) {
            if ((x === null || x === void 0 ? void 0 : x.symbol) === streaming.symbol) {
                return __assign(__assign({}, x), { changePercentage: streaming.hasOwnProperty("".concat(period, "_ChangePercentage"))
                        ? streaming["".concat(period, "_ChangePercentage")]
                        : streaming.changePercentage, change: streaming.hasOwnProperty("".concat(period, "_ChangePrice"))
                        ? streaming["".concat(period, "_ChangePrice")]
                        : streaming.changePrice, latestTradePrice: streaming.curPrice, status: streaming.marketStatus, lastUpdatedDate: moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.updatedTime).format("hh:mm:ss A"), high: x.high < streaming.high ? streaming.high : x.high, low: x.low > streaming.low ? streaming.low : x.low, highDate: x.high < streaming.high
                        ? moment(streaming.updatedTime).format("DD-MMM-YY")
                        : x.highDate, lowDate: x.low > streaming.low
                        ? moment(streaming.updatedTime).format("DD-MMM-YY")
                        : x.lowDate });
            }
        }
        return x;
    });
};
export var marketStreamingUpdate = function (data, streaming, period) {
    return data.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.symbol) === streaming.symbol) {
            return __assign(__assign({}, x), { changePercentage: streaming.hasOwnProperty("".concat(period, "_ChangePercentage"))
                    ? streaming["".concat(period, "_ChangePercentage")]
                    : streaming.changePercentage, changePrice: streaming.hasOwnProperty("".concat(period, "_ChangePrice"))
                    ? streaming["".concat(period, "_ChangePrice")]
                    : streaming.changePrice, latestTradePrice: streaming.curPrice, status: streaming.marketStatus, lastUpdatedDate: moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.updatedTime).format("hh:mm:ss A") });
        }
        return x;
    });
};
export var drivingMarketStreamingUpdate = function (data, streaming, period) {
    var symData = data.get(streaming.symbol);
    if (symData) {
        data.set(streaming.symbol, __assign(__assign({}, symData), { changePercentage: streaming.hasOwnProperty("".concat(period, "_ChangePercentage"))
                ? streaming["".concat(period, "_ChangePercentage")]
                : streaming.changePercentage, changePrice: streaming.hasOwnProperty("".concat(period, "_ChangePrice"))
                ? streaming["".concat(period, "_ChangePrice")]
                : streaming.changePrice, latestTradingPrice: streaming.curPrice, status: streaming.marketStatus, lastUpdatedDate: moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.updatedTime).format("hh:mm:ss A"), high: symData.high < streaming.high ? streaming.high : symData.high, low: symData.low > streaming.low ? streaming.low : symData.low }));
    }
    return data;
};
export var priceBuzzerStreamingUpdate = function (data, streaming) {
    var symData = data.get(streaming.symbol);
    if (symData) {
        data.set(streaming.symbol, __assign(__assign({}, symData), { latestTradingPrice: streaming.curPrice, lastUpdatedDate: moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.updatedTime).format("hh:mm:ss A") }));
    }
    return data;
};
export var marketTodayStream = function (data, streaming) {
    return data.map(function (x) {
        if (x.symbol) {
            if (x.symbol === streaming.symbol) {
                return __assign(__assign({}, x), { change: streaming.changePrice, changePercentage: streaming.changePercentage, stockValue: streaming.curPrice, todayHigh: streaming.high, todayLow: streaming.low, 
                    // status: streaming.marketStatus,
                    lastUpdatedDate: moment(streaming.updatedTime).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.updatedTime).format("hh:mm:ss A") });
            }
        }
        return x;
    });
};
export var marketStatusStream = function (data, streaming) {
    return data && data.length > 0 && streaming && streaming !== null
        ? data.map(function (x) {
            var _a;
            if (x.exchange &&
                streaming.status &&
                ((_a = streaming === null || streaming === void 0 ? void 0 : streaming.status) === null || _a === void 0 ? void 0 : _a[x === null || x === void 0 ? void 0 : x.exchange])) {
                return __assign(__assign({}, x), { status: streaming.status[x.exchange], lastUpdatedDate: moment(streaming.lut).format("DD-MMM-YY"), lastUpdatedTime: moment(streaming.lut).format("hh:mm:ss A") });
            }
            else
                return x;
        })
        : data
            ? data
            : [];
};
